import type { BaseFreightRate, MileageBand } from '@api/useFreight/types'
import { Horizontal, MaterialIcon, Texto } from '@gravitate-js/excalibrr'
import type { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-community'
import React from 'react'

export function useMileageBandColumnDefs(selectedRate: BaseFreightRate | null) {
  // Get the rate type from the selected rate
  const rateType = selectedRate?.unit || ''
  const formattedRateType = rateType ? ` (${rateType})` : ''

  const columnDefs: ColDef<MileageBand>[] = [
    {
      headerName: 'Miles',
      field: 'from_mile',
      minWidth: 80,
      sortable: true,
      sort: 'asc' as const,
      filter: 'agNumberColumnFilter',
      filterParams: {
        defaultOption: 'equals',
        allowedCharPattern: '\\d\\-\\.',
      },
      cellRenderer: ({ data }: ICellRendererParams<MileageBand>) => (
        <Horizontal verticalCenter gap={4}>
          <Texto>{data?.from_mile}</Texto>
          <Texto appearance='hint' style={{ display: 'flex', alignItems: 'center' }}>
            <MaterialIcon icon='keyboard_arrow_right' className='pr-1' />
            {data?.to_mile === undefined ? (
              <Texto style={{ fontStyle: 'italic' }}>(N/A)</Texto>
            ) : data?.to_mile === null ? (
              <Texto style={{ fontStyle: 'italic' }}>(N/A)</Texto>
            ) : (
              data?.to_mile
            )}
          </Texto>
        </Horizontal>
      ),
    },
    {
      headerName: `Rate${formattedRateType}`,
      field: 'rate',
      minWidth: 80,
      valueFormatter: ({ value }: ValueFormatterParams<MileageBand>) => `$${Number(value).toFixed(5)}`,
      filter: 'agNumberColumnFilter',
      filterParams: {
        defaultOption: 'equals',
        allowedCharPattern: '\\d\\-\\.',
      },
    },
  ]

  return columnDefs
}
